const Attendance = () => {
    return (
        <div>
            <h1>Attendance</h1>
        </div>
    );
};

export default Attendance;